// @ts-nocheck

/**
 * * `pirate_adventure` - Pirate Adventure
 * `space_exploration` - Space Exploration
 * `fairy_tale` - Fairy Tale
 * `underwater_world` - Underwater World
 * `jungle_safari` - Jungle Safari
 * `dinosaur_land` - Dinosaur Land
 * `superhero` - Superhero
 * `princess_castle` - Princess Castle
 */
export type ThemeEnum = typeof ThemeEnum[keyof typeof ThemeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ThemeEnum = {
  pirate_adventure: "pirate_adventure",
  space_exploration: "space_exploration",
  fairy_tale: "fairy_tale",
  underwater_world: "underwater_world",
  jungle_safari: "jungle_safari",
  dinosaur_land: "dinosaur_land",
  superhero: "superhero",
  princess_castle: "princess_castle",
} as const;
